import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
// import Inspector from "./Inspector.js";
import UpdateVehicle from "./updateVehicalTypes";
import Vehicles from "./vehicle";

class AdminVehicleRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/vehicle" component={Vehicles} />
        <Route exact path="/vehicle/edit/:id" component={UpdateVehicle} />
        {/* <Route exact path="/inspector/view/:iId" component={ViewInspector} /> */}
      </Switch>
    );
  }
}

export default AdminVehicleRoutes;



// WEBPACK FOOTER //
// ./src/admin/vehicle/adminVehiclesRoutes.js